import { render } from "./component-contract.vue?vue&type=template&id=015e0dbf"
import script from "./component-contract.vue?vue&type=script&setup=true&lang=js"
export * from "./component-contract.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-contract.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "015e0dbf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('015e0dbf', __exports__)) {
    api.reload('015e0dbf', __exports__)
  }
  
  module.hot.accept("./component-contract.vue?vue&type=template&id=015e0dbf", () => {
    api.rerender('015e0dbf', render)
  })

}


export default __exports__